module.exports = __webpack_public_path__ + "a886f744d90fe840ec8862438d18ff73.svg";